import styled from 'styled-components';

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};

  padding: 1.5rem;

  gap: 1rem;
`;

export const QuestionTitle = styled.span`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.grayDark3};
  font-family: 'Source Sans Pro';
`;

export const AccordionContainer = styled.div`
  display: grid;
  gap: 1rem;

  .hefesto-accordion__item .hefesto-accordion__item__header {
    display: flex;
    gap: 1rem;

    .hefesto-accordion__title h4 {
      font-weight: 600;
      font-size: 1rem;
      line-height: 24px;
      color: #555555;
      font-family: ${({ theme }) => theme.fonts.workSans};
      margin-bottom: 0;
    }
  }
`;
